import { z } from 'zod';
import { dateParser, enumParser } from '#validation';
import { memberRefSchema } from '#web-service-api/member';
import { ServiceIdentityStatus } from './service-identity-status';
export const ServiceIdentityBaseSchema = z.object({
    id: z.string(),
    accountId: z.string(),
    createdByMemberId: z.string(),
    createdByMember: memberRefSchema.nullish(),
    tokenPreview: z.string(),
    status: enumParser(ServiceIdentityStatus),
    createdAt: dateParser(),
    isSingleUse: z.boolean().default(false),
    lastUsedAt: dateParser().nullable(),
    expiresAt: dateParser().nullable(),
});
